import React from 'react'
import { useLocation } from 'react-router-dom'
import LoginImage from '../../../components/LoginImage'
import ChangePassword from '../../DonorContactInformation/components/ChangePassword'

const ChangeTemporaryPassword = () => {
  const location = useLocation()
  return (
    <div id="login-view">
      <div className="login-container">
        <h5 className="form-title">{__.trans('register.change-temporary-password')}</h5>
        <ChangePassword oldPassword={location.state.oldPassword} />
      </div>
      <LoginImage />
    </div>
  )
}

export default ChangeTemporaryPassword
